// designed to wrap the matomo tag manager script so we better can control when to add the script to the page.

define([], function () {
  var matomoTagManagerContainerId = "";
  var matomoSiteId = "";
  var matomoWrapper = {
    isTracking: false,

    /// Assumes and requires that cookiesettings has been initialized elsewhere.
    /// var settingsObj = {
    ///	  matomoTagManagerContainerId: "XXXXX",
    ///   matomoSiteId: ""
    /// }
    init: function (settingsObj) {

      const cookiesettings = window?.uppsala?.cookieSettingsInstance;

      if (cookiesettings === undefined) {
        console.warn("Cookie settings not found. MatomoWrapper will not work.")
        return;
      }

      matomoTagManagerContainerId = settingsObj.matomoTagManagerContainerId ?? "";
      matomoSiteId = settingsObj.matomoSiteId ?? "";

      if (cookiesettings.isStatisticsAllowed() === true) {
        this.setStatisticsConsentMatomoFlag();
        this.addMatomoTagManagerScript();
      }

      // reevaluate if consent cookies change
      var that = this;
      cookiesettings.onConsentChanged.push(function () {
        if (cookiesettings.isStatisticsAllowed() === true && that.isTracking === false) {
          that.setStatisticsConsentMatomoFlag();
          that.addMatomoTagManagerScript();
        }
      });
    },
    addMatomoTagManagerScript: function () {
      // Inserts matomo tag manager. It holds matomo analytics tag and we decided not to care if other scripts are inserted through tagmanager.
      var _mtm = window._mtm = window._mtm || [];
      _mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });
      var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
      g.async = true; g.src = 'https://matomo.uppsala.se/js/container_' + matomoTagManagerContainerId + '.js';

      // Wait before inserting the script to make sure require.js has loaded correctly.
      setTimeout(function () {
        s.parentNode.insertBefore(g, s);
        this.isTracking = true;
      }.bind(this), 1000);
    },

    // Sets a specific matomo cookie to let matomo know that user has given consent.
    // We have chosen to keep track of user consent instead of matomo so we need to call this function on every pageview as long as the user has given consent.
    // documentation: https://developer.matomo.org/guides/tracking-consent
    setStatisticsConsentMatomoFlag: function () {
      // even if matomo analytics is not loaded yet, it will handle thease commands once it is loaded.
      var _paq = window._paq = window._paq || [];

      // sets tracker url as it seems matomo gets confused some times if you only rely on tag manager container id.
      _paq.push(["setTrackerUrl", 'https://matomo.uppsala.se/matomo.php']);
      _paq.push(["setSiteId", matomoSiteId]);

      // set consent given
      _paq.push(['setConsentGiven']);
    }

  };

  return matomoWrapper;
});